import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { FileUploadInput } from 'components'
import usePermissions from 'hooks/usePermissions'
import constants from 'constants/index'
import useStyles from './styles'

const ActivityAttachments = ({
  activity,
  onRemoveAttachment,
  isShow = false,
}) => {
  const classes = useStyles()
  const permissions = usePermissions()
  const canManage =
    !isShow && permissions.permitted(constants.permissions.KANBAN_TASKS.MANAGE)

  const isCrossBoard = !!activity?.targetCompanyId
  const handleRemoveApiFile =
    canManage && !isCrossBoard && activity?.id && onRemoveAttachment
      ? (attachmentId) => onRemoveAttachment(activity.id, attachmentId)
      : null

  return (
    <Box>
      <Typography className={classes.fieldLabel} color="textSecondary">
        Anexos
      </Typography>
      <FileUploadInput
        controlName="attachments"
        title="Arraste ou clique para adicionar anexos"
        multiple
        controllerBar
        hasDownloadFile
        disabled={!canManage || isCrossBoard}
        onRemoveApiFile={handleRemoveApiFile}
        accept={constants.activities.TASK_ATTACHMENT_FILE_TYPES}
        blockUnaccepted
      />
    </Box>
  )
}

ActivityAttachments.propTypes = {
  activity: PropTypes.object,
  onRemoveAttachment: PropTypes.func,
  isShow: PropTypes.bool,
}

export default ActivityAttachments
